import axiosService from 'services/axiosService';
import { DOMAIN } from 'constants';

const url = 'api/v2/experts';

export const getExperts = () => {
  return axiosService.get(`${DOMAIN}/${url}`, true);
}